import commonApi from './CommonApi.js';

export default {
	postMessage: async (viewModel) => {
		return await commonApi().post('/v1/forums/postMessage', viewModel)
			.then((response) => {
				return response;
			})
			.catch((error) => {
				return error.response;
			});
	},
	getNotificationForum: async (parameters) => {
		return await commonApi().get('/v1/forums/getNotificationForum', { params: parameters })
			.then((response) => {
				return response.data;
			})
			.catch((error) => {
				console.log(error.response);
			});
	}
}